import moment from 'moment-timezone';

export function diffInMonths(dateFrom: string, dateTo: string | null = null): number {
  const from = moment(dateFrom);
  const to = dateTo ? moment(dateTo) : moment();
  return to.diff(from, 'month');
}
